import React from "react";
import { CustomSegmented } from "Components/CustomSegmented";

type Props = {
  onChoose: (v: number) => void;
  value: number;
  isDisabled: boolean;
  width?: number | string;
  background?: string;
};

export const SwitcherDispute = ({ onChoose, value, isDisabled, width, background }: Props) => {
  const options = [
    { value: 0, label: "Disable Return" },
    { value: 1, label: "Enable Return" },
    { value: 2, label: "Return impossible" },
  ];

  return (
    <CustomSegmented
      options={options}
      value={value}
      disabled={isDisabled}
      onChange={(v) => onChoose(Number(v))}
      style={{ ...(width ? { width } : {}), ...(background ? { background } : {}) }}
    />
  );
};
